import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV3';
import { ButtonBase, Stack } from '@mui/material';
import { DatePicker } from '@components/Datepicker';
import { fr } from 'date-fns/locale/fr';

interface InputDateRangeProps {
    name: string;
    id?: string;
    onChange?: (value: { start: any; end: any }) => void;
}

const InputDateRange: React.FC<InputDateRangeProps> = ({ name, onChange }) => {
    const { control, watch } = useFormContext();
    const start = watch(`${name}.start`);
    const end = watch(`${name}.end`);

    return (
        <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={fr}>
            {/* @ts-ignore */}
            <Stack spacing={1} direction="row">
                <Controller
                    name={`${name}.start`}
                    control={control}
                    render={({ field }) => (
                        <DatePicker
                            {...field}
                            slots={{
                                openPickerIcon: () => (
                                    <i className="fi fi-br-calendar" style={{ fontSize: 16 }} />
                                )
                            }}
                            value={field.value || null}
                            onChange={date => { field.onChange(date); onChange?.({ start: date, end }); }}
                            maxDate={end}
                            slotProps={{
                                textField: {
                                    size: 'small',
                                    placeholder: 'JJ/MM/AAAA',
                                    InputProps: {
                                        startAdornment: <span style={{ marginRight: 8 }}>Du:</span>,
                                    }
                                },
                            }}
                        />
                    )}
                />
                <Controller
                    name={`${name}.end`}
                    control={control}
                    render={({ field, fieldState }) => (
                        <DatePicker
                            {...field}
                            slots={{
                                openPickerIcon: () => (
                                    <i className="fi fi-br-calendar" style={{ fontSize: 16 }} />
                                )
                            }}
                            value={field.value || null}
                            onChange={date => { field.onChange(date); onChange?.({ start, end: date }); }}
                            minDate={start}
                            slotProps={{
                                textField: {
                                    size: 'small',
                                    error: Boolean(fieldState.error),
                                    helperText: fieldState.error?.message,
                                    placeholder: 'JJ/MM/AAAA',
                                    InputProps: field.value
                                        ? {
                                            // endAdornment: (
                                            //     <ButtonBase
                                            //         type="button"
                                            //         onClick={() => field.onChange(null)}
                                            //         sx={{
                                            //             background: 'none',
                                            //             border: 'none',
                                            //             cursor: 'pointer',
                                            //             color: theme => theme.palette.mode === 'dark' ? theme.palette.common.white : theme.palette.primary.main,
                                            //         }}
                                            //     >
                                            //         <i className="fi fi-br-cross-small" style={{ fontSize: 24 }} />
                                            //     </ButtonBase>
                                            // ),
                                            startAdornment: <span style={{ marginRight: 8 }}>Au:</span>,
                                        }
                                        : {
                                            startAdornment: <span style={{ marginRight: 8 }}>Au:</span>,
                                        }
                                },
                            }}
                        />
                    )}
                />
            </Stack>
        </LocalizationProvider>
    );
};

export default InputDateRange;
